export const MICROPHONE = 'microphone'
export const NOTIFICATIONS = 'notifications'

export const DEFAULT = 'default'
export const GRANTED = 'granted'
export const PROMPT = 'prompt'
export const DENIED = 'denied'
